<template>
  <div class="ecm__card-transaction">
    <div class="ecm__card-transaction__header">
      <i class="fas fa-shopping-bag"></i>
      <p>{{ formatDate(order.createdAt) }}</p>
      <p class="ecm__card-transaction__header-status success" v-if="order.order_status === 'settlement'">Success</p>
      <p class="ecm__card-transaction__header-status pending" v-else-if="order.order_status === 'pending'">Pending</p>
      <p class="ecm__card-transaction__header-status expire" v-else-if="order.order_status === 'expire'">Expire</p>
      <p>{{ order.invoice }}</p>
    </div>
    <div class="ecm__card-transaction__content">
      <div class="ecm__card-transaction__content-cover">
        <img :src="order.Order_items[0].Book.cover" alt="">
      </div>
      <div class="ecm__card-transaction__content-desc">
        <p class="ecm__card-transaction__content-desc-title">{{ order.Order_items[0].Book.title }}</p>
        <p class="ecm__card-transaction__content-desc-total">{{ order.Order_items[0].quantity }} {{ formatSpellBook(order.Order_items[0].quantity) }} x Rp {{ formatPrice(order.Order_items[0].Book.price) }}</p>
        <p class="ecm__card-transaction__content-desc-another"
          v-if="order.Order_items.length > 1"
        >+{{ order.Order_items.length - 1 }} another {{ formatSpellBook(order.Order_items.length - 1) }}</p>
      </div>
      <div class="ecm__card-transaction__content-total-price">
        <p>Total Shopping</p>
        <p>Rp {{ formatPrice(order.total_price + order.cost) }}</p>
      </div>
    </div>
    <div class="ecm__card-transaction__footer">
      <button @click="$router.push(`/detail/transaction/${order.id}`)">Detail Transaction</button>
    </div>
  </div>
</template>

<script>
import formatDisplay from '@/mixins/formatDisplay.js'

export default {
  name: 'Card_Transaction',
  mixins: [formatDisplay],
  props: {
    order: {
      type: Object,
      default: null
    }
  },
  methods: {
    formatSpellBook (totalBook) {
      if (totalBook > 1) {
        return 'books'
      }
      return 'book'
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__card-transaction {
  margin-bottom: 10px;
  border: 1px solid rgba(128, 128, 128, 0.453);
  padding: 15px;
  .ecm__card-transaction__header,
  .ecm__card-transaction__content,
  .ecm__card-transaction__footer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .ecm__card-transaction__header {
    color: var(--color-blue-background);
    font-weight: 500;
    font-size: 13px;
    p {
      margin-left: 10px;
    }
    .ecm__card-transaction__header-status {
      padding: 2px 10px;
      border-radius: 10px;
      font-size: 11px;
      color: white;
      background: var(--color-blue-background);
      &.success {
        background: #34BD4A;
      }
      &.pending {
        background: #FDB400;
      }
      &.expire {
        background: rgb(253, 17, 17);
      }
    }
  }
  .ecm__card-transaction__content {
    padding: 10px 0;
    .ecm__card-transaction__content-cover {
      height: 100px;
      overflow: hidden;
      width: 90px;
      img {
        height: 100%;
      }
    }
    .ecm__card-transaction__content-desc {
      align-self: flex-start;
      width: 650px;
      word-break: break-all;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.945);
      .ecm__card-transaction__content-desc-title {
        font-weight: 450;
        text-transform: uppercase;
      }
      .ecm__card-transaction__content-desc-another {
        margin-top: 5px;
      }
    }
    .ecm__card-transaction__content-total-price {
      width: 180px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 80px;
      padding: 0 0 0 30px;
      border-left: 2px dashed rgba(0, 0, 0, 0.562);
      margin-left: auto;
      p {
        color: rgba(0, 0, 0, 0.945);
        text-align: center;
        font-size: 15px;
        font-weight: 500;
        &:last-child {
          color: var(--color-pink);
          font-size: 20px;
        }
      }
    }
  }
  .ecm__card-transaction__footer {
    justify-content: flex-end;
    button {
      padding: 5px 13px;
      outline: none;
      border: none;
      background: var(--color-blue-background);
      font-weight: 500;
      color: white;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>
